// 系统模块枚举
// export enum SystemModule {
//   SYSTEM = 'SYSTEM', // 系统设置
//   YJGL = 'YJGL',    // 项目业绩
//   ZBGL = 'ZBGL',    // 造价指标
//   LJXT = 'LJXT',    // 量价协同
//   ZXZY = 'ZXZY',    // 咨询作业
//   ZLWD = 'ZLWD',    // 资料文档
// }

import { useNavigate as useRouterNavigate, useSearchParams } from 'react-router-dom'
import { SystemEnum } from "@/config/enum"
import { DefaultNavPath } from '@/config'

// 模块默认路由映射
const moduleDefaultRoutes: Record<SystemEnum, string> = {
  [SystemEnum.SYSTEM]: '/project-center/list',
  [SystemEnum.YJGL]: '/cloud-project/list',
  [SystemEnum.ZBGL]: '/indicator/englist',
  [SystemEnum.LJXT]: '/indicator/englist',
  [SystemEnum.ZXZY]: '/indicator/englist',
  [SystemEnum.ZLWD]: '/document/domainList',
  [SystemEnum.SHRY]: '/shry/list',
}

// 指标路由（默认路由）

/**
 * 导航 Hook，返回默认路由跳转函数
 * @returns navigateToDefaultRoute 函数
 */
const useNavigate = () => {
  const navigate = useRouterNavigate()
  const [searchParams] = useSearchParams()

  const navigateToDefaultRoute = () => {
    // 检查是否有重定向参数
    const redirectUrl = searchParams.get('redirect')
    
    if (redirectUrl) {
      try {
        // 手动解码URL，确保中文字符和特殊字符正确解码
        let decodedUrl = decodeURIComponent(redirectUrl)
        
        // 处理Hash Router模式：去掉可能的 /#/ 前缀
        if (decodedUrl.startsWith('/#/')) {
          decodedUrl = decodedUrl.slice(2) // 去掉 /#，保留 /
        }
        
        console.log('重定向到:', decodedUrl)
        navigate(decodedUrl, { replace: true })
      } catch (error) {
        console.error('URL解码失败:', error)
        // 解码失败时跳转到默认路径
        navigate(DefaultNavPath, { replace: true })
      }
    } else {
      // 否则跳转到默认路径
      navigate(DefaultNavPath, { replace: true })
    }
  }

  return { navigateToDefaultRoute }
}
export default useNavigate
